/**
 * Error codes for the application. These are the keys we find in the client's en.json file
 * and are used to display error messages to the user. We need this object to be synchronized
 * with the client's en.json file. This is to make errors translatable.
 */
export var ErrorMessages;
(function (ErrorMessages) {
    ErrorMessages["fileUploadTooManyTypesProvided"] = "fileUploadTooManyTypesProvided";
    ErrorMessages["fileUploadMissingRequiredAttributes"] = "fileUploadMissingRequiredAttributes";
    ErrorMessages["fileUploadProcessingError"] = "fileUploadProcessingError";
    ErrorMessages["fileUploadTypeCannotBeDetermined"] = "fileUploadTypeCannotBeDetermined";
    ErrorMessages["fileUploadIsNotACsv"] = "fileUploadIsNotACsv";
    ErrorMessages["fileUploadFileTooLarge"] = "fileUploadFileTooLarge";
    ErrorMessages["fileUploadInvalidType"] = "fileUploadInvalidType";
    ErrorMessages["fileUploadEmptyLocationForBehovsverktyg"] = "fileUploadEmptyLocationForBehovsverktyg";
    ErrorMessages["fileUploadEmptyLocationForInVision"] = "fileUploadEmptyLocationForInVision";
    ErrorMessages["fileUploadLocationSetForCffF"] = "fileUploadLocationSetForCffF";
    ErrorMessages["fileUploadInvalidDateFormat"] = "fileUploadInvalidDateFormat";
    ErrorMessages["fileUploadDateCannotBeInThePast"] = "fileUploadDateCannotBeInThePast";
    ErrorMessages["fileUploadNotAUnitId"] = "fileUploadNotAUnitId";
    ErrorMessages["fileUploadNotAnActivityId"] = "fileUploadNotAnActivityId";
    ErrorMessages["startDateMustBeBeforeEndDate"] = "startDateMustBeBeforeEndDate";
    ErrorMessages["transformUnrecognizedOrgNodeId"] = "transformUnrecognizedOrgNodeId";
    ErrorMessages["transformPathNotFoundForOrgNodeId"] = "transformPathNotFoundForOrgNodeId";
    ErrorMessages["transformActivityMatchError"] = "transformActivityMatchError";
    ErrorMessages["transformSingleMatchExpectation"] = "transformSingleMatchExpectation";
    ErrorMessages["transformOrgNodeMatchErrorByJob"] = "transformOrgNodeMatchErrorByJob";
    ErrorMessages["transformOrgNodeRetrievalFailure"] = "transformOrgNodeRetrievalFailure";
    ErrorMessages["transformIncorrectHeadcountLength"] = "transformIncorrectHeadcountLength";
    ErrorMessages["transformActivityAndDateOverlap"] = "transformActivityAndDateOverlap";
    ErrorMessages["transformMinLessThanMax"] = "transformMinLessThanMax";
    ErrorMessages["headcountPlanNotFound"] = "headcountPlanNotFound";
    ErrorMessages["headcountAutomaticOrCustomRequirement"] = "headcountAutomaticOrCustomRequirement";
    ErrorMessages["headcountRowUpdateFailure"] = "headcountRowUpdateFailure";
    ErrorMessages["methodSavedEvaluationFailed"] = "methodSavedEvaluationFailed";
    ErrorMessages["validationInvalidDateColumn"] = "validationInvalidDateColumn";
    ErrorMessages["validationInvalidDayType"] = "validationInvalidDayType";
    ErrorMessages["validationInvalidActivityList"] = "validationInvalidActivityList";
    ErrorMessages["validationEmptyActivityList"] = "validationEmptyActivityList";
    ErrorMessages["validationInvalidHeadcount"] = "validationInvalidHeadcount";
    ErrorMessages["validationHeadcountTooSmall"] = "validationHeadcountTooSmall";
    ErrorMessages["validationHeadcountTooBig"] = "validationHeadcountTooBig";
    ErrorMessages["validationTooManyTimeSegments"] = "validationTooManyTimeSegments";
    ErrorMessages["validationTooFewTimeSegments"] = "validationTooFewTimeSegments";
    ErrorMessages["validationDuplicateTimeForActivity"] = "validationDuplicateTimeForActivity";
    ErrorMessages["failedToSaveActivity"] = "failedToSaveActivity";
    ErrorMessages["failedToFetchActivity"] = "failedToFetchActivity";
    ErrorMessages["failedToAssignActivity"] = "failedToAssignActivity";
    ErrorMessages["invalidActivityOrDepartment"] = "invalidActivityOrDepartment";
    ErrorMessages["activityAlreadyExists"] = "activityAlreadyExists";
    ErrorMessages["activityDoesNotExist"] = "activityDoesNotExist";
    ErrorMessages["assignmentNotFound"] = "assignmentNotFound";
    ErrorMessages["failedToUnassignActivity"] = "failedToUnassignActivity";
    ErrorMessages["departmentDoesNotExist"] = "departmentDoesNotExist";
    ErrorMessages["invalidCharactersInActivityName"] = "invalidCharactersInActivityName";
    ErrorMessages["departmentAlreadyMappedForDate"] = "departmentAlreadyMappedForDate";
    ErrorMessages["mappingDatesCannotOverlap"] = "mappingDatesCannotOverlap";
    ErrorMessages["mappingExistsForActivityBetweenDates"] = "mappingExistsForActivityBetweenDates";
    ErrorMessages["dateCannotBeInThePast"] = "dateCannotBeInThePast";
    ErrorMessages["dateInvalidDateFormat"] = "dateInvalidDateFormat";
    ErrorMessages["dateStartDateCannotBeInThePast"] = "dateStartDateCannotBeInThePast";
    ErrorMessages["dateEndDateCannotBeInThePast"] = "dateEndDateCannotBeInThePast";
    ErrorMessages["dateInvalidDateRange"] = "dateInvalidDateRange";
    ErrorMessages["startDateNotEditable"] = "startDateNotEditable";
    ErrorMessages["activityHasCoworkers"] = "activityHasCoworkers";
    ErrorMessages["loaderDuplicateActivityName"] = "loaderDuplicateActivityName";
    ErrorMessages["loaderDuplicateActivityNameInFile"] = "loaderDuplicateActivityNameInFile";
    ErrorMessages["loaderMissingCountryCode"] = "loaderMissingCountryCode";
    ErrorMessages["loaderFileNotProvided"] = "loaderFileNotProvided";
    ErrorMessages["loaderNoNewActivities"] = "loaderNoNewActivities";
    ErrorMessages["loaderMissingActivityName"] = "loaderMissingActivityName";
    ErrorMessages["loaderMissingDepartmentId"] = "loaderMissingDepartmentId";
    ErrorMessages["loaderDepartmentNotFound"] = "loaderDepartmentNotFound";
    ErrorMessages["failedToFetchDriverByCountry"] = "failedToFetchDriverByCountry";
    ErrorMessages["internalServerError"] = "internalServerError";
})(ErrorMessages || (ErrorMessages = {}));
//# sourceMappingURL=errorCodes.mjs.map